import { createContext, useContext, useEffect, useMemo } from 'react'
import { io } from 'socket.io-client'
import { Helper } from '@utils'
import { store, Actions } from '@store'
import { useSelector } from 'react-redux'
import Incoming from '../commons/popups/incoming'
const SocketContext: any = createContext(null)

const SocketProvider = (props: any) => {
  const user = Helper.getUser()
  const incomingCallInfo = useSelector((state: any) => state.incomingCallInfo)
  const opts = {
    path: '/socket',
    transports: ['websocket'],
    reconnectionDelay: 5000,
    reconnection: true,
    reconnectionAttempts: 5,
    auth: {
      token: user?.token,
    },
  }
  const socketDomain = process.env.SOCKET_URL
  const socket: any = useMemo(() => {
    return io(`${socketDomain}`, opts)
  }, [user?.token])

  const onConnect = () => {
    console.log('Socket connected')
  }

  const onDisconnect = (err: any) => {
    console.error('Socket disconnect', err)
    socket.emit('disconnect')
  }

  const onReceivedByMe = async () => {
    store.dispatch(Actions.reset('incomingCallInfo'))
  }

  const onCallReceived = (data) => {
    store.dispatch(Actions.set('incomingCallInfo', data))
  }

  const onCallEnd = () => {
    store.dispatch(Actions.reset('incomingCallInfo'))
  }

  const handleCallEnd = () => {
    socket.emit('sendCallEnd', {
      callSenderId: incomingCallInfo?.callSenderId,
      callReceiverId: incomingCallInfo?.callReceiverId,
      receiverId: incomingCallInfo?.callSenderId,
      conversationId: incomingCallInfo?.conversationId,
      status: 'No Response',
      call: incomingCallInfo?.callType,
    })
    store.dispatch(Actions.reset('incomingCallInfo'))
  }

  const handleCallAnswer = () => {
    Helper.saveCallSession({
      ...incomingCallInfo,
      type: 'incoming',
    })
    store.dispatch(Actions.reset('incomingCallInfo'))
    window.open(`/${user?.role}/call`, '_blank')
  }

  const onError = (err: any) => {
    console.log(err, 'error socket')
  }
  useEffect(() => {
    if (!socket) return
    socket.on('connect', onConnect)
    socket.on('disconnected', onDisconnect)
    socket.on('onCallReceived', onCallReceived)
    socket.on('onReceivedByMe', onReceivedByMe)
    socket.on('onCallEnd', onCallEnd)
    socket.on('error', onError)
    return () => {
      socket.off('connect', onConnect)
      socket.off('disconnect', onDisconnect)
      socket.off('onCallReceived', onCallReceived)
      socket.off('onReceivedByMe', onReceivedByMe)
      socket.off('onCallEnd', onCallEnd)
      socket.off('error', onError)
    }
  }, [socket])
  return (
    <SocketContext.Provider value={{ socket: socket }}>
      {props.children}
      {!!incomingCallInfo?.sender?.id && (
        <Incoming
          visible={true}
          sender={incomingCallInfo?.receiver}
          onEnd={handleCallEnd}
          onAnswer={handleCallAnswer}
        />
      )}
    </SocketContext.Provider>
  )
}

export const useSocket = () => {
  return useContext(SocketContext)
}
export default SocketProvider
